import { utcDay } from 'd3-time';
import { sendEvent } from '@mrkt/features/Platform/googleAnalytics';
import { applyMetricSuffix } from '../../shared/lib/numberHelpers';
import { spotifyOpenLink } from '../../shared/lib/urlHelpers';

const IN_APP_URL = 'artists.spotify.com/c/';

export const lastSevenDays = (latestDate, dateFormat) => {
  const latestDay = new Date(latestDate);
  const lastWeekDay = utcDay.offset(latestDay, -6);
  return `${dateFormat(lastWeekDay)} – ${dateFormat(latestDay)}`;
};

export const numFollowersFormatting = numFollowers => {
  if (numFollowers === -1) {
    return `-`;
  }
  return `${applyMetricSuffix(parseInt(numFollowers, 10))} Followers`;
};

export const numFormatting = num =>
  applyMetricSuffix(num ? parseInt(num, 10) : 0);

export const playlistLinksOut = (uri, isPersonalized) => uri && !isPersonalized;

export const goToPlaylist = uri => {
  window.open(spotifyOpenLink(uri), '_blank');
  sendEvent({
    eventCategory: 'Outbound',
    eventAction: 'playlists',
    eventLabel: uri,
  });
};

export const isInternalUrl = url => url.includes(IN_APP_URL);

export const getRelativeUrl = internalUrl => {
  const endOfInAppPrefix = internalUrl.indexOf(IN_APP_URL) + IN_APP_URL.length;
  return internalUrl.substring(endOfInAppPrefix - 1, internalUrl.length);
};
